import lgCloiServebot from '../../../../assets/images/learn/lg-cloi-servebot.png';
import vdPudubot from '../../../../assets/images/learn/vd-pudubot.png';
import keenon from '../../../../assets/images/learn/keenon-m-t10.png';
import { cEl } from '../../../../util';

function ServingRobot() {
    const page = cEl('div');
    page.classList.add('learn-page');
    page.innerHTML = `
    <div class="gray-box">
        <h2>서빙 로봇</h2>
        <div class="img-container">
            <div class="img-wrapper border-radius">
                <img src="${lgCloiServebot}" alt="LG전자 CLOi ServeBot">
                <span>LG전자 CLOi ServeBot</span>
            </div>
            <div class="img-wrapper border-radius">
                <img src="${vdPudubot}" alt="브이디컴퍼니 푸두봇">
                <span>브이디컴퍼니 푸두봇</span>
            </div>
            <div class="img-wrapper border-radius">
                <img src="${keenon}" alt="KEENON M-T10">
                <span>KEENON M-T10</span>
            </div>
        </div>
        <div class="description-container">
            <div class="description-wrapper" style="flex: 0 0 250px">
                <div class="description-topic">사용처</div>
                <ul class="description-list">
                    <li>부서 내 물품 이동</li>
                </ul>
            </div>
            <div class="description-wrapper" style="flex: 0 0 250px">
                <div class="description-topic">선반 종류</div>
                <ul class="description-list">
                    <li>오픈식 선반</li>
                </ul>
            </div>
            <div class="description-wrapper" style="flex: 0 0 250px">
                <div class="description-topic">장점</div>
                <ul class="description-list">
                    <li>안정적인 업무 수행</li>
                    <li>저렴한 가격</li>
                    <li>쉬운 사용법</li>
                </ul>
            </div>
            <div class="description-wrapper" style="flex: 0 0 250px">
                <div class="description-topic">주의점</div>
                <ul class="description-list">
                    <li>수동 충전 필요</li>
                    <li>로봇마다 최대 중량, 선반 높이 등<br>세부 사항 확인 필요</li>
                </ul>
            </div>
        </div>
    </div>`;

    return page;
}

export default ServingRobot;
